import { hasDispatchLowca, hasJeppesenMaDispatch } from 'ff/common/system';

export default function renderDivider() {
    const el = document.createElement('hr');
    el.style.width = 'calc(100% - 16px)';
    el.style.borderStyle = 'solid';
    el.style.borderColor = 'rgba(255, 255, 255, 0.15)';
    el.style.borderImage = 'initial';
    el.style.borderWidth = '1px 0px 0px';
    el.style.background = 'none transparent';
    el.style.height = '0';
    el.style.margin = '0px 8px 10px';
    return el;
}

export function renderOrgTopDivider() {
    const isJeppesenDispatchUser =
        hasDispatchLowca() || hasJeppesenMaDispatch();
    const el = renderDivider();
    // if Jeppesen logo, adjust the margin
    el.style.margin = isJeppesenDispatchUser
        ? '0px 8px 10px 8px'
        : '0px 8px 10px';
    return el;
}
